/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

/**
 * Created by Dimitri Sebeschuk on 09.06.15.
 */
(function (Tc, $, SCS) {
	'use strict';

	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.6.4 or greater
	 */
	Tc.Module.LazyContainer = Tc.Module.extend({

		//Timeout for scroll stop event 250ms
		SCROLL_STOP_TIMEOUT: 250,
		THRESHOLD: 60,

		on: function (callback) {
			var mod = this;
			mod.isEditMode = window.CQ && window.CQ.WCM && window.CQ.WCM.isEditMode(true);
			mod.url = mod.$ctx.data('url');
			if (window.location.href.indexOf('wcmmode=disabled') > 0 || mod.isEditMode) {
				mod.url = SCS.portal.addParamToUrl(mod.url, 'wcmmode', 'disabled');
			}

			mod.loadingIndicator = $('<div>').addClass('loading-indicator');
			mod.errorMessage = mod.$ctx.find('.content-error').first();

			callback();
		},

		after: function () {
			var mod = this;
			if (mod.$ctx.data('preload-content')) {
				return;
			}
			//init lazy loading
			if (mod.$ctx.data('scroll-lazy')) {
				if (!mod.isScrolledIntoView()) {
					//scroll-lazy is true and content not into view
					mod.onScrollProxy = $.proxy(mod.onScroll, mod);
					$(window).on('scroll', mod.onScrollProxy);
					return;
				}
			}

			if (typeof mod.$ctx.data('delay') === 'number') {
				setTimeout($.proxy(mod.loadContent, mod), mod.$ctx.data('delay'));
			} else {
				mod.loadContent();
			}

		},

		loadContent: function () {
			var mod = this;
			if (mod.$ctx.hasClass('loading') || mod.$ctx.hasClass('js-lazycontainer-loaded')) {
				return;
			}
			mod.$ctx.addClass('loading');
			if (mod.url) {
				mod.errorMessage.addClass('hidden');
				mod.$ctx.prepend(mod.loadingIndicator);
				$.ajax({
					url: mod.url
				}).done(function (response) {
					mod.$ctx.removeClass('loading');
					mod.$ctx.addClass('js-lazycontainer-loaded');
					mod.loadingIndicator.detach();
					mod.$ctx.html(response);
					SCS.utils.initNewModules(mod.$ctx);
				}).fail(function () {
					mod.loadingIndicator.detach();
					mod.$ctx.removeClass('loading');
					mod.errorMessage.removeClass('hidden');
				});
			} else {
				mod.$ctx.removeClass('loading');
			}
		},

		isScrolledIntoView: function () {
			var mod = this,
				fold = (window.innerHeight ? window.innerHeight : $(window).height()) + $(window).scrollTop();
			//Content below will be loaded
			return fold > mod.$ctx.offset().top - mod.THRESHOLD;
		},

		onScroll: function () {
			var mod = this;

			if (mod.scrollStopTimeoutHandler) {
				clearTimeout(mod.scrollStopTimeoutHandler);
				mod.scrollStopTimeoutHandler = null;
			}
			mod.scrollStopTimeoutHandler = setTimeout($.proxy(mod.onScrollStop, mod), mod.SCROLL_STOP_TIMEOUT);
		},

		onScrollStop: function () {
			var mod = this;
			if (mod.isScrolledIntoView()) {
				mod.loadContent();
				if (mod.onScrollProxy) {
					$(window).off('scroll', mod.onScrollProxy);
				}
			}
		}

	});
}(window.Tc, window.Tc.$, window.SCS));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.LazyContainer.js
// module id = 150
// module chunks = 0